import { Controller, useFormContext } from 'react-hook-form';

import { AkselLocale, Select as AkselSelect } from 'components/form/aksel';

/* Map DOM strings back to the original option value type. */
export default function Select({
	name,
	label,
	defaultValue = null,
	options = [],
	fullWidth = false,
	size = 'medium',
	required = false,
	disabled = false,
	sx = null,
	helperText,
	error = false,
	...props
}) {
	const { control } = useFormContext();

	const style = {
		...(fullWidth ? { width: '100%' } : {}),
		...(sx ?? {}),
	};

	return (
		<Controller
			name={name}
			control={control}
			defaultValue={defaultValue ?? ''}
			render={({
				field: {
					value,
					onChange,
					disabled: fieldDisabled,
					...fieldProps
				},
				fieldState,
			}) => {
				const printed =
					value === null || value === undefined ? '' : String(value);
				/* A blank option prevents the browser from selecting the first unmatched value. */
				const unmatched = !options.some(
					option => String(option.value) === printed
				);

				return (
					<AkselLocale>
						<AkselSelect
							id={`${name}-select`}
							label={label}
							size={size}
							required={required}
							style={style}
							value={
								value === null || value === undefined
									? ''
									: String(value)
							}
							onChange={event => {
								const picked = options.find(
									option =>
										String(option.value) ===
										event.target.value
								);
								onChange(
									picked ? picked.value : event.target.value
								);
							}}
							{...fieldProps}
							{...props}
							description={helperText}
							error={fieldState.error?.message || error}
							disabled={fieldDisabled || disabled}
						>
							{unmatched && <option value="">Velg …</option>}
							{options.map((option, index) => (
								<option
									key={index}
									value={String(option.value)}
									disabled={option.disabled}
								>
									{option.label}
								</option>
							))}
						</AkselSelect>
					</AkselLocale>
				);
			}}
		/>
	);
}
